<!-- Heading -->
<mdb-card class="mb-4 wow fadeIn">
  <!--Card content-->
  <mdb-card-body class="d-sm-flex justify-content-between">
    <div style="display: contents">
      <h4 class="mb-sm-0">
        <span>Manage Users</span>
      </h4>

      <form class="d-flex md-form justify-content-center my-0">
        <button mdbBtn size="sm" class="my-0 p btn-trakly">New User</button>
        <button mdbBtn size="sm" class="my-0 p btn-trakly-action" (click)="GetBrokerUsers()">Search</button>
      </form>
    </div>
  </mdb-card-body>
</mdb-card>
<!-- Heading -->

<!-- Heading -->
<mdb-card class="mb-4 wow fadeIn">
  <!--Card content-->
  <mdb-card-body class="d-sm-flex justify-content-between">
    <!-- Form -->
    <div class="text-center border border-light p-5 w-100">
      <div *ngIf="!busy">
        <!--Error Display-->
        <div class="col">
          <div *ngIf="showError" class="alert alert-danger text-center font-weight-bold" role="alert">
            {{ errorMsg }}
          </div>
        </div>
        <table mdbTable *ngIf="!busy" hover="true" small="true" responsive="true">
          <thead>
            <tr>
              <th scope="col" class="col-3">Full Name</th>
              <th scope="col" class="col-3">Email</th>
              <th scope="col" class="col-2">Cellphone</th>
              <th scope="col" class="col-3">Status</th>
              <th scope="col" class="col-1"></th>
              <th scope="col" class="col-1"></th>
              <th scope="col" class="col-1"></th>
              <th scope="col" class="col-1"></th>
            </tr>
          </thead>
          <tbody>
            <tr mdbTableCol *ngFor="let user of users">
              <td class="align-middle">{{ user.profile.fullName }}</td>
              <td class="align-middle">{{ user.user.email }}</td>
              <td class="align-middle">{{ user.user.mobile }}</td>
              <td class="align-middle" *ngIf="user.user.active == true">Active</td>
              <td class="align-middle" *ngIf="user.user.active == false">Disabled</td>
              <td>
                <a class="border dropdown-item text-center my-1" size="sm" (click)="ShowModal(user, 'userInfoModal')" mdbWavesEffect
                  >User Details</a
                >
              </td>
              <td>
                <a class="border dropdown-item text-center my-1" size="sm" (click)="ShowModal(user, 'userFiaPinsModal')" mdbWavesEffect
                  >FIA Pins</a
                >
              </td>
              <td>
                <a class="border dropdown-item text-center my-1" size="sm" (click)="ShowModal(user, 'userDocumentsModal')" mdbWavesEffect
                  >User Documents</a
                >
              </td>
              <td>
                <a
                  class="border dropdown-item text-center my-1"
                  size="sm"
                  (click)="ShowModal(user, 'userFiaApplicationModal')"
                  mdbWavesEffect
                  >FIA Application</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!--Loading-->
      <div class="col-12 text-center" *ngIf="busy">
        <div *ngIf="busy" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </mdb-card-body>
</mdb-card>

<!-- User Info/Edit Modal -->
<div
  mdbModal
  #userInfoModal="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="userInfoModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">{{ selectedUserProfile.fullName }} - User Information</h4>
      </div>
      <div class="modal-body">
        <div *ngIf="!busy">
          <!--Error Display-->
          <div class="col">
            <div *ngIf="showError" class="alert alert-danger text-center font-weight-bold" role="alert">
              {{ errorMsg }}
            </div>
          </div>
          <!--Main Body-->
          <div class="d-block col-12 mb-3 text-center">
            <p class="font-weight-bold mb-1">Personal Information</p>
          </div>
          <!-- Full name -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="selectedUserProfile.fullName"
              mdbInput
              mdbValidate
              name="fullName"
              type="text"
              id="fullName"
              class="form-control"
              #fullName="ngModel"
              required
            />
            <label for="fullName">Full name</label>
            <mdb-error *ngIf="fullName.invalid && (fullName.dirty || fullName.touched)">First name is required </mdb-error>
            <mdb-success *ngIf="fullName.valid && (fullName.dirty || fullName.touched)"></mdb-success>
          </div>

          <!-- Display name -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="selectedUserProfile.displayName"
              mdbInput
              mdbValidate
              name="displayName"
              type="text"
              id="displayName"
              class="form-control"
              #displayName="ngModel"
              required
            />
            <label for="displayName">Display name</label>
            <mdb-error *ngIf="displayName.invalid && (displayName.dirty || displayName.touched)">Last name is required </mdb-error>
            <mdb-success *ngIf="displayName.valid && (displayName.dirty || displayName.touched)"></mdb-success>
          </div>

          <!-- E-mail -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="selectedUser.email"
              mdbInput
              mdbValidate
              name="email"
              type="text"
              id="email"
              class="form-control"
              #email="ngModel"
              required
              [pattern]="regexForEmail"
            />
            <label for="email">E-mail</label>
            <mdb-error *ngIf="email.invalid && (email.dirty || email.touched)">Email address not valid </mdb-error>
            <mdb-success *ngIf="email.valid && (email.dirty || email.touched)"></mdb-success>
          </div>

          <!-- Cellphone -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="selectedUser.mobile"
              mdbInput
              mdbValidate
              name="mobile"
              type="text"
              id="mobile"
              class="form-control"
              #mobile="ngModel"
              required
              [pattern]="'\\+27 [0-9]{9}$'"
              placeholder="+27 xxxxxxxxx"
            />
            <label for="mobile">Cellphone</label>
            <mdb-error *ngIf="mobile.invalid && (mobile.dirty || mobile.touched)">Cellphone number not valid </mdb-error>
            <mdb-success *ngIf="mobile.valid && (mobile.dirty || mobile.touched)"></mdb-success>
          </div>

          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="selectedUserProfile.idNumber"
              mdbInput
              mdbValidate
              name="idNumber"
              type="text"
              id="idNumber"
              class="form-control"
              #idNumber="ngModel"
              required
              placeholder="South african ID number"
            />
            <label for="idNumber">ID Number</label>
            <mdb-error *ngIf="idNumber.invalid && (idNumber.dirty || idNumber.touched)">ID number not valid</mdb-error>
            <mdb-success *ngIf="idNumber.valid && (idNumber.dirty || idNumber.touched)"></mdb-success>
          </div>

          <div class="d-block col-12 mb-3 text-center">
            <p class="font-weight-bold mb-1">Sars Details</p>
          </div>
          <!-- Fia Amount -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="selectedUserProfile.fiaAmount"
              mdbInput
              mdbValidate
              name="fiaAmount"
              type="number"
              id="fiaAmount"
              class="form-control"
              #fiaAmount="ngModel"
            />
            <label for="fiaAmount">Fia Amount</label>
            <mdb-error *ngIf="fiaAmount.invalid && (fiaAmount.dirty || fiaAmount.touched)">Fia Amount</mdb-error>
            <mdb-success *ngIf="fiaAmount.valid && (fiaAmount.dirty || fiaAmount.touched)"></mdb-success>
          </div>

          <!-- Income Tax ref number -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="selectedUserProfile.incomeTaxReferenceNumber"
              mdbInput
              mdbValidate
              name="incomeTaxReferenceNumber"
              type="text"
              id="incomeTaxReferenceNumber"
              class="form-control"
              #incomeTaxReferenceNumber="ngModel"
            />
            <label for="incomeTaxReferenceNumber">Income Tax Reference Number</label>
            <mdb-error *ngIf="incomeTaxReferenceNumber.invalid && (incomeTaxReferenceNumber.dirty || incomeTaxReferenceNumber.touched)">
              Income Tax Reference number not valid</mdb-error
            >
            <mdb-success *ngIf="incomeTaxReferenceNumber.valid && (incomeTaxReferenceNumber.dirty || incomeTaxReferenceNumber.touched)">
            </mdb-success>
          </div>

          <!-- Sars Username -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="selectedUserProfile.sarsUsername"
              mdbInput
              mdbValidate
              name="sarsUsername"
              type="text"
              id="sarsUsername"
              class="form-control"
              #sarsUsername="ngModel"
            />
            <label for="sarsUsername">Sars Login Username</label>
            <mdb-error *ngIf="sarsUsername.invalid && (sarsUsername.dirty || sarsUsername.touched)"
              >Sars Login Username not valid</mdb-error
            >
            <mdb-success *ngIf="sarsUsername.valid && (sarsUsername.dirty || sarsUsername.touched)"></mdb-success>
          </div>

          <!-- Sars Password -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="selectedUserProfile.sarsPassword"
              mdbInput
              mdbValidate
              name="sarsPassword"
              type="text"
              id="sarsPassword"
              class="form-control"
              #sarsPassword="ngModel"
            />
            <label for="sarsPassword">Sars Login Password</label>
            <mdb-error *ngIf="sarsPassword.invalid && (sarsPassword.dirty || sarsPassword.touched)"
              >Sars Login Password not valid</mdb-error
            >
            <mdb-success *ngIf="sarsPassword.valid && (sarsPassword.dirty || sarsPassword.touched)"></mdb-success>
          </div>
        </div>
        <!--Loading-->
        <div class="col-12 text-center">
          <div *ngIf="busy" class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <!--Save btn-->
      <div class="modal-footer justify-content-right">
        <button *ngIf="!busy" type="button" mdbBtn color="trakly" class="relative waves-light" (click)="saveClicked()">Save</button>
      </div>
    </div>
  </div>
</div>

<!-- User Fia Pins Modal -->
<div
  mdbModal
  #userFiaPinsModal="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-fluid" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="userFiaPinsModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">{{ selectedUserProfile.fullName }} - FIA Pins</h4>
      </div>
      <div class="modal-body">
        <div *ngIf="!busy">
          <!--Error Display-->
          <div class="col">
            <div *ngIf="showError" class="alert alert-danger text-center font-weight-bold" role="alert">
              {{ errorMsg }}
            </div>
          </div>
          <!--Main Body-->
          <table mdbTable *ngIf="!busy && selectedUserFiaApplcations?.length > 0" hover="true" small="true" responsive="true">
            <thead>
              <tr>
                <th scope="col" class="col-1">Status</th>
                <th scope="col" class="col-2">Request Reference Number</th>
                <th scope="col" class="col-1">Case Number</th>
                <th scope="col" class="col-2">Date Requested</th>
                <th scope="col" class="col-1">Requested Fia Amount</th>
                <th scope="col" class="col-2">Planned Investment Date</th>
                <th scope="col" class="col-1">Pin</th>
                <th scope="col" class="col-1">Pin Issue Date</th>
                <th scope="col" class="col-1">Pin Expiry Date</th>
              </tr>
            </thead>
            <tbody>
              <tr mdbTableCol *ngFor="let apps of selectedUserFiaApplcations">
                <div *ngIf="apps.status" [ngSwitch]="apps.status">
                  <td class="align-middle" *ngSwitchCase="1">Pending</td>
                  <td class="align-middle" *ngSwitchCase="2">Awaiting Relevant Material</td>
                  <td class="align-middle" *ngSwitchCase="3">Review In Progress</td>
                  <td class="align-middle" *ngSwitchCase="4">Approved</td>
                  <td class="align-middle" *ngSwitchCase="5">Declined</td>
                  <td class="align-middle" *ngSwitchCase="6">Expired</td>
                  <td class="align-middle" *ngSwitchCase="7">Complaint</td>
                  <td class="align-middle" *ngSwitchDefault>Scheduled</td>
                </div>
                <td class="align-middle" *ngIf="!apps.status">Scheduled</td>

                <td class="align-middle" *ngIf="apps.requestRefNumber">{{ apps.requestRefNumber }}</td>
                <td class="align-middle" *ngIf="!apps.requestRefNumber">-</td>

                <td class="align-middle" *ngIf="apps.caseNumber">{{ apps.caseNumber }}</td>
                <td class="align-middle" *ngIf="!apps.caseNumber">-</td>

                <td class="align-middle" *ngIf="apps.dateRequested">{{ apps.dateRequested | date }}</td>
                <td class="align-middle" *ngIf="!apps.dateRequested">-</td>

                <td class="align-middle">{{ apps.requestedFiaAmount | currency: "ZAR" : "symbol-narrow" }}</td>
                <td class="align-middle">{{ apps.plannedInvestmentDate | date }}</td>
                <td class="align-middle" *ngIf="apps.pin">{{ apps.pin }}</td>
                <td class="align-middle" *ngIf="!apps.pin">-</td>
                <td class="align-middle" *ngIf="apps.pin">{{ apps.pinIssueDate | date }}</td>
                <td class="align-middle text-center" *ngIf="!apps.pin">-</td>
                <td class="align-middle" *ngIf="apps.pin">{{ apps.pinExpiryDate | date }}</td>
                <td class="align-middle text-center" *ngIf="!apps.pin">-</td>
              </tr>
            </tbody>
          </table>
          <div class="col">
            <div
              *ngIf="!busy && selectedUserFiaApplcations?.length == 0"
              class="alert alert-info text-center font-weight-bold"
              role="alert"
            >
              No Fia Pins available
            </div>
          </div>
        </div>
        <!--Loading-->
        <div class="col-12 text-center">
          <div *ngIf="busy" class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- User documents Modal -->
<div
  mdbModal
  #userDocumentsModal="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="userDocumentsModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">{{ selectedUserProfile.fullName }} - Documents</h4>
      </div>
      <div class="modal-body">
        <div *ngIf="!busy">
          <!--Error Display-->
          <div class="col">
            <div *ngIf="showError" class="alert alert-danger text-center font-weight-bold" role="alert">
              {{ errorMsg }}
            </div>
          </div>
          <!--Main Body-->
          <div class="selection-item-full">
            <p>Manage supporting documents</p>
            <div class="dropzone" filedropzone="">
              <div class="text-wrapper">
                <i class="fas fa-upload"></i>
                <p class="hidden-sm-down">
                  <a class="is-link"><strong>Browse</strong></a> to select files from your computer
                </p>
                <p class="hidden-sm-up">Click/tap to add your files or drag and drop them here</p>
              </div>
              <input class="hidden" type="file" multiple="multiple" #file (change)="onFileChange($event)" />
            </div>
          </div>

          <div class="d-block col-12" *ngIf="selectedUserNewDocuments?.length > 0">
            <p class="font-weight-bold mb-1">New Documents</p>
          </div>
          <table class="col-12" mdbTable *ngIf="selectedUserNewDocuments?.length > 0" hover="true" small="true" responsive="true">
            <thead>
              <tr>
                <th scope="col" class="col-4">File Name</th>
                <th scope="col" class="col-6">Type</th>
                <th scope="col" class="col-2"></th>
              </tr>
            </thead>
            <tbody>
              <tr mdbTableCol *ngFor="let docs of selectedUserNewDocuments">
                <td class="align-middle">{{ docs.fileName }}</td>
                <td class="align-middle">
                  <select
                    class="form-control"
                    [(ngModel)]="docs.fileType"
                    placeholder="Select document type"
                    style="display: block !important"
                  >
                    <option *ngFor="let mediatype of mediaTypes" ngValue="{{ mediatype.description }}">{{ mediatype.description }}</option>
                  </select>
                </td>
                <td class="align-middle">
                  <a class="border dropdown-item text-center my-1" size="sm" (click)="removeFile(docs.fileName)" mdbWavesEffect>Remove</a>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="d-block col-12" *ngIf="selectedUserDocuments?.length > 0">
            <p class="font-weight-bold mb-1">Existing Documents</p>
          </div>
          <table mdbTable *ngIf="selectedUserDocuments?.length > 0" hover="true" small="true" responsive="true">
            <thead>
              <tr>
                <th scope="col" class="col-2">Name</th>
                <th scope="col" class="col-3">Date Created</th>
                <th scope="col" class="col-3">Type</th>
                <th scope="col" class="col-2"></th>
                <th scope="col" class="col-2"></th>
              </tr>
            </thead>
            <tbody>
              <tr mdbTableCol *ngFor="let doc of selectedUserDocuments">
                <td class="align-middle">{{ doc.name }}</td>
                <td class="align-middle">{{ doc.createdDate | date }}</td>
                <td class="align-middle">{{ doc.fileType }}</td>
                <td class="align-middle">
                  <a class="border dropdown-item text-center my-1" size="sm" (click)="DownloadFile(doc.id)" mdbWavesEffect>Download</a>
                </td>
                <td class="align-middle">
                  <a class="border dropdown-item text-center my-1" size="sm" (click)="deleteFile(doc.id)" mdbWavesEffect>Delete</a>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="col">
            <div *ngIf="!busy && selectedUserDocuments?.length == 0" class="alert alert-info text-center font-weight-bold" role="alert">
              No supporting documents uploaded
            </div>
          </div>
        </div>
        <!--Loading-->
        <div class="col-12 text-center">
          <div *ngIf="busy" class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <!--Save btn-->
      <div class="modal-footer justify-content-right">
        <button *ngIf="!busy" type="button" mdbBtn color="trakly" class="relative waves-light" (click)="mediaSaveClicked()">Save</button>
      </div>
    </div>
  </div>
</div>

<!-- User Fia Application Modal -->
<div
  mdbModal
  #userFiaApplicationModal="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="userFiaApplicationModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">{{ selectedUserProfile.fullName }} - FIA Application</h4>
      </div>
      <div class="modal-body">
        <div *ngIf="!busy">
          <!--Error Display-->
          <div class="col">
            <div *ngIf="showError" class="alert alert-danger text-center font-weight-bold" role="alert">
              {{ errorMsg }}
            </div>
          </div>
          <!--Main Body-->
          <div class="d-block col-12 mb-3 text-center">
            <p class="font-weight-bold mb-1">New FIA Application</p>
          </div>
          <!-- Planned Investment Date -->
          <div class="md-form col-6" style="margin-top: 5px">
            <mat-form-field>
              <input
                matInput
                [matDatepicker]="picker"
                placeholder="Planned Investment Date"
                [matDatepickerFilter]="myDateFilter"
                required
                [(ngModel)]="newFia.plannedInvestmentDate"
              />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker startView="month" [startAt]="startDate"></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- FIA Amount -->
          <div class="md-form col-12" style="margin-top: 5px">
            <input
              [(ngModel)]="newFia.fiaAmount"
              mdbInput
              mdbValidate
              name="fiaAmount"
              type="number"
              id="fiaAmount"
              class="form-control"
              #fiaAmount="ngModel"
              required
            />
            <label for="fiaAmount">FIA Amount</label>
            <mdb-error *ngIf="fiaAmount.invalid && (fiaAmount.dirty || fiaAmount.touched)">FIA Amount is required </mdb-error>
            <mdb-success *ngIf="fiaAmount.valid && (fiaAmount.dirty || fiaAmount.touched)"></mdb-success>
          </div>
        </div>
        <!--Loading-->
        <div class="col-12 text-center">
          <div *ngIf="busy" class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <!--Save btn-->
      <div class="modal-footer justify-content-right">
        <button *ngIf="!busy" type="button" mdbBtn color="trakly" class="relative waves-light" (click)="fiaApplicationApplyClicked()">
          Apply
        </button>
      </div>
    </div>
  </div>
</div>

<div
  mdbModal
  #confirmDeleteModal="mdbModal"
  class="modal fade top"
  id="confirmDeleteModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="confirmDeleteModal"
  aria-hidden="true"
>
  <div class="modal-dialog modal-sm modal-notify modal-danger" role="document">
    <!--Content-->
    <div class="modal-content text-center">
      <!--Header-->
      <div class="modal-header d-flex justify-content-center">
        <p class="heading">Are you sure you would like to delete this document?</p>
      </div>
      <!--Body-->
      <div class="modal-body">
        <mdb-icon fas icon="times" size="4x" class="animated rotateIn"></mdb-icon>
      </div>
      <!--Footer-->
      <div class="modal-footer justify-content-center">
        <a mdbBtn color="danger" outline="true" class="waves-effect" mdbWavesEffect>Yes</a>
        <a type="button" mdbBtn color="danger" class="waves-effect" mdbWavesEffect data-dismiss="modal" (click)="cancelDelete()">No</a>
      </div>
    </div>
    <!--/.Content-->
  </div>
</div>
